import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../services/auth.service";

export const useRegister = () => {
  const navigate = useNavigate();

  const { isPending: isLoading, mutate: register } = useMutation({
    mutationFn: (data) => authService.register(data.username, data.email, data.password),
    onSuccess: () => {
      navigate("/login");
      console.log("success");
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Something went wrong");
    },
  });

  return { register, isLoading };
};
